import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'project-create-importer-upload-flow.project-create-screen.templates.title',
		defaultMessage: 'Template',
		description: 'Heading for template selection modal',
	},
	button: {
		id: 'project-create-importer-upload-flow.project-create-screen.templates.button',
		defaultMessage: 'Change template',
		description: 'Button text for Cancel',
	},
});
